<template>
  <div class="page-view">
    <div class="scroll-view-wrapper exercise-question-list">
      <e-header title='查看问题' :showBtn="false" />

      <div class="tab">
        <div class="tab-item" :class="{active: item.value === currentTab}"
          v-for="item in tabList" :key="item.value"
          @click="selectTab(item)"
        >{{item.label}}</div>
      </div>

      <div class="tab-content">
        <div class='no-data' v-if="!list.length">
          <no-data />
        </div>
        <div v-else>
          <template v-for="item in list" :key="item.dialogId">
            <question-item :item="item" />
          </template>
        </div>
      </div>

      <div class="ui-safe-area-inset"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import utils from '@/public/utils'
import { exerReq } from '@/api'

import EHeader from '@/components/exercise/header/index.vue'
import NoData from '@/components/exercise/no-data/index.vue'
import QuestionItem from '@/components/exercise/question/item.vue'

const { proxy: { $showLoading, $hideLoading, $toast } } = getCurrentInstance()

const tabList = Object.freeze([{
  label: '其他学员问题',
  value: 1
},
{
  label: '我的问题',
  value: 2
}])

const currentTab = ref(1)
const selectTab = item => {
  if (item.value !== currentTab.value) {
    currentTab.value = item.value
    getList()
  }
}
const id = ref(utils.getQueryParams('id') || 0)
const pageNo = ref(1)
const pageCount = ref(0)
const timer = ref(null)
const isScrollLoad = ref(false)
// const showLoading = ref(false)
const list = ref([])

const scrollLoadList = () => {
  const winHeight = window.innerHeight
  const scrollTop = document.scrollingElement.scrollTop
  const scrollViewHeight =
    document.querySelector(".scroll-view-wrapper").offsetHeight - 20
  const realFunc = () => {
    if (
      winHeight + scrollTop >= scrollViewHeight &&
      pageNo.value < pageCount.value
    ) {
      pageNo.value += 1
      // this.showLoading = true
      // this.getArticleList()
    } else {
      // this.isScrollLoad = true
      isScrollLoad.value = true
    }
  }
  if (isScrollLoad.value) {
    isScrollLoad.value = false
    timer.value = window.requestAnimationFrame(realFunc)
  }
}

const getList = async () => {
  if (!id.value) {
    $toast('id不存在')
    return
  }
  const params = {
    taskId: id.value
  }
  const fetchApi = currentTab.value === 1 ? exerReq.getOtherQuestionList : exerReq.getMyQuestionList
  $showLoading()
  const res = await fetchApi(params)
  $hideLoading()
  if (Number(res.code) === 200) {
    list.value = res.data
  } else {
    $toast(res.message)
  }
}

onMounted(() => {
  getList()
  window.addEventListener(
    "scroll",
    scrollLoadList,
    utils.isPassive() ? { passive: true, capture: true } : true
  )
})
onBeforeUnmount(() => {
  window.cancelAnimationFrame(timer.value)
  window.removeEventListener(
    "scroll",
    scrollLoadList,
    utils.isPassive() ? { passive: true, capture: true } : true
  )
})

</script>

<style lang="scss" scoped>
@import "~@/components/exercise/style/default.scss";

.exercise-question-list {
  background-color: #F5F5F7;
  box-sizing: border-box;
  .tab {
    background-color: #fff;
    height: 90px;
    width: 100%;
    padding: 0 28px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #EFEFEF;
    &-item {
      font-size: 32px;
      color: #969799;
      height: 100%;
      line-height: 90px;
      margin-right: 40px;
      &.active {
        color: #232323;
        position: relative;
        font-weight: bold;
        &::after {
          content: '';
          width: 44px;
          height: 8px;
          background: #FF6600;
          border-radius: 6px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .tab-content {
    position: absolute;
    top: 1.78rem;
    bottom: 0;
    left: 0;
    right: 0;

    .no-data {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

}
</style>
